import { cx, cva } from 'cva';
import React, { forwardRef, useRef, Fragment, useState } from 'react';
import { Transition, Dialog as Dialog$1, Disclosure, Listbox, Portal, Combobox } from '@headlessui/react';
import { ExclamationTriangleIcon, CheckCircleIcon, InformationCircleIcon, DocumentArrowUpIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon, XMarkIcon, ChevronLeftIcon, EllipsisHorizontalIcon, ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid';
import { formatFileSize } from '@metatrustlabs/web-utils';
import { useFloating, flip, offset, shift } from '@floating-ui/react-dom';
import { useFloating as useFloating$1, flip as flip$1, offset as offset$1, shift as shift$1, useInteractions, useHover, useClick } from '@floating-ui/react';

var calculateClasses = function calculateClasses(className, defaultClass) {
  if (!className) {
    return defaultClass;
  }
  if (typeof className === "string") {
    return cx(defaultClass, className);
  } else {
    return cx(defaultClass);
  }
};
var classx = function classx(originalClass, replacer) {
  if (!replacer) {
    return originalClass;
  }
  if (typeof replacer === "string") {
    return cx(originalClass, replacer);
  } else {
    return replacer(originalClass);
  }
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var ProgressCircular = function ProgressCircular(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'h-5 w-5' : _ref$className;
  return React.createElement("svg", {
    className: cx('animate-spin ', className),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, React.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), React.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
};

var _excluded = ["isLoading", "className", "intent", "pill", "size", "href", "loadingIcon", "linkElement", "leadingIcon", "trailingIcon", "children"];
// const BUTTON_BASE_CLASS =
//   "group shadow-sm flex items-center justify-center active:shadow-none";
var BUTTON_BASE_CLASS = "group flex items-center justify-center active:shadow-none";
var DEFAULT_DISABLED_CLASS = "disabled:border-gray-300 disabled:text-gray-400 disabled:bg-gray-200 disabled:shadow-none";
var buttonStyle = /*#__PURE__*/cva(BUTTON_BASE_CLASS, {
  variants: {
    intent: {
      primary: ["text-orange-500 hover:text-orange-600", "border border-orange-500 hover:border-orange-600 outline-orange-500", "bg-white hover:bg-orange-50 active:bg-orange-100", DEFAULT_DISABLED_CLASS],
      secondary: ["text-gray-500 hover:text-gray-600", "border border-gray-300 hover:border-gray-400 outline-gray-400", "bg-white hover:bg-gray-50 active:bg-gray-100", DEFAULT_DISABLED_CLASS],
      danger: ["text-white hover:text-red-50", "border border-red-500 hover:border-red-600 outline-red-200", "bg-red-500 hover:bg-red-600 active:bg-red-700", DEFAULT_DISABLED_CLASS],
      highlight: ["text-white hover:text-white", "border border-orange-400 outline-orange-300", "bg-gradient-to-br from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600 active:from-orange-600 active:to-red-600", "disabled:border-gray-300 disabled:text-gray-400 disabled:from-gray-200 disabled:to-gray-200 disabled:shadow-none"]
    },
    size: {
      xs: ["text-xs", "gap-1 py-1"],
      sm: ["text-sm", "gap-1.5 py-1.5"],
      base: ["text-base", "gap-2 py-2"],
      lg: ["text-lg", "gap-3 py-3"],
      xl: ["text-xl", "gap-4 py-3"]
    },
    pill: {
      "true": "",
      "false": ""
    }
  },
  compoundVariants: [{
    size: "xs",
    pill: true,
    "class": "rounded-full px-4"
  }, {
    size: "xs",
    pill: false,
    "class": "rounded px-3"
  }, {
    size: "sm",
    pill: true,
    "class": "rounded-full px-8"
  }, {
    size: "sm",
    pill: false,
    "class": "rounded-md px-5"
  }, {
    size: "base",
    pill: true,
    "class": "rounded-full px-10"
  }, {
    size: "base",
    pill: false,
    "class": "rounded-lg px-5"
  }, {
    size: "lg",
    pill: true,
    "class": "rounded-full px-12"
  }, {
    size: "lg",
    pill: false,
    "class": "rounded-lg px-8"
  }, {
    size: "xl",
    pill: true,
    "class": "rounded-full px-12"
  }, {
    size: "xl",
    pill: false,
    "class": "rounded-lg px-10"
  }],
  defaultVariants: {
    intent: "primary",
    size: "base"
  }
});
var iconStyle = /*#__PURE__*/cva("flex items-center justify-center", {
  variants: {
    intent: {
      primary: "text-orange-500 group-hover:text-orange-600",
      secondary: "text-gray-500 group-hover:text-gray-600",
      danger: "text-white group-hover:text-red-50",
      highlight: "text-white group-hover:text-white"
    },
    size: {
      xs: "w-4 h-4",
      sm: "w-5 h-5",
      base: "w-6 h-6",
      lg: "w-7 h-7",
      xl: "w-8 h-8"
    },
    hasLeading: {
      "true": ""
    },
    hasTrailing: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "xs",
    hasLeading: true,
    "class": "-ml-1"
  }, {
    size: "xs",
    hasTrailing: true,
    "class": "-mr-1"
  }, {
    size: "sm",
    hasLeading: true,
    "class": "-ml-1"
  }, {
    size: "sm",
    hasTrailing: true,
    "class": "-mr-1"
  }, {
    size: "base",
    hasLeading: true,
    "class": "-ml-1.5"
  }, {
    size: "base",
    hasTrailing: true,
    "class": "-mr-1.5"
  }, {
    size: "lg",
    hasLeading: true,
    "class": "-ml-2"
  }, {
    size: "lg",
    hasTrailing: true,
    "class": "-mr-2"
  }, {
    size: "xl",
    hasLeading: true,
    "class": "-ml-3"
  }, {
    size: "xl",
    hasTrailing: true,
    "class": "-mr-3"
  }],
  defaultVariants: {
    intent: "primary",
    size: "base"
  }
});
var withFullSize = function withFullSize(icon) {
  return React.cloneElement(icon, {
    className: (icon.props.className || "") + " w-full h-full"
  });
};
var Button = /*#__PURE__*/forwardRef(function buttonWithRef(_ref, ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "primary" : _ref$intent,
    _ref$pill = _ref.pill,
    pill = _ref$pill === void 0 ? false : _ref$pill,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? "" : _ref$href,
    _ref$loadingIcon = _ref.loadingIcon,
    loadingIcon = _ref$loadingIcon === void 0 ? React.createElement(ProgressCircular, {
      className: "h-5/6 w-5/6"
    }) : _ref$loadingIcon,
    _ref$linkElement = _ref.linkElement,
    Link = _ref$linkElement === void 0 ? "a" : _ref$linkElement,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var iconClass = iconStyle({
    intent: intent,
    size: size,
    hasLeading: !!leadingIcon,
    hasTrailing: !!trailingIcon
  });
  var btnClass = classx(buttonStyle({
    intent: intent,
    pill: pill,
    size: size
  }), className);
  var iconLeftActual = React.createElement(React.Fragment, null, leadingIcon && React.createElement("div", {
    className: iconClass
  }, isLoading ? loadingIcon : withFullSize(leadingIcon)), isLoading && !leadingIcon && !trailingIcon && React.createElement("div", {
    className: iconClass
  }, loadingIcon));
  var iconRightActual = React.createElement(React.Fragment, null, trailingIcon && React.createElement("div", {
    className: iconClass
  }, isLoading ? loadingIcon : withFullSize(trailingIcon)));
  if (href) {
    return React.createElement(Link, {
      href: href,
      className: btnClass + " max-w-fit cursor-pointer"
    }, iconLeftActual, children, iconRightActual);
  } else {
    return React.createElement("button", Object.assign({
      className: btnClass,
      ref: ref
    }, props), iconLeftActual, children, iconRightActual);
  }
});

var iconWrapperCls = /*#__PURE__*/cva("flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full", {
  variants: {
    intent: {
      info: "bg-blue-100",
      success: "bg-lime-50",
      warning: "bg-orange-100",
      error: "bg-red-100"
    }
  }
});
var iconCls = /*#__PURE__*/cva("h-6 w-6", {
  variants: {
    intent: {
      info: "text-blue-600",
      success: "text-lime-600",
      warning: "text-orange-500",
      error: "text-red-600"
    }
  }
});
var getIcon = function getIcon(variant) {
  var wrapperClass = iconWrapperCls(variant);
  var iconClass = iconCls(variant);
  switch (variant.intent) {
    case "info":
      return React.createElement("div", {
        className: wrapperClass
      }, React.createElement(InformationCircleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
    case "success":
      return React.createElement("div", {
        className: wrapperClass
      }, React.createElement(CheckCircleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
    case "warning":
      return React.createElement("div", {
        className: wrapperClass
      }, React.createElement(ExclamationTriangleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
    case "error":
      return React.createElement("div", {
        className: wrapperClass
      }, React.createElement(ExclamationTriangleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
  }
  return React.createElement(React.Fragment, null);
};
var Alert = function Alert(_ref) {
  var title = _ref.title,
    content = _ref.content,
    icon = _ref.icon,
    isOpen = _ref.isOpen,
    confirmButton = _ref.confirmButton,
    cancelButton = _ref.cancelButton,
    extraFooter = _ref.extraFooter,
    className = _ref.className,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "info" : _ref$intent,
    _ref$confirmLabel = _ref.confirmLabel,
    confirmLabel = _ref$confirmLabel === void 0 ? "Confirm" : _ref$confirmLabel,
    _ref$cancelLabel = _ref.cancelLabel,
    cancelLabel = _ref$cancelLabel === void 0 ? "Cancel" : _ref$cancelLabel;
  var cancelButtonRef = useRef(null);
  var iconActual = icon || getIcon({
    intent: intent
  });
  var confirmButtonActual = confirmButton || React.createElement(Button, {
    type: "button",
    intent: intent === "error" ? "danger" : "highlight",
    size: "sm",
    onClick: function onClick() {
      return onConfirm();
    }
  }, confirmLabel);
  var cancelButtonActual = cancelButton || React.createElement(Button, {
    type: "button",
    intent: "secondary",
    size: "sm",
    onClick: function onClick() {
      return onCancel();
    },
    ref: cancelButtonRef
  }, cancelLabel);
  return React.createElement(Transition.Root, {
    show: isOpen,
    as: Fragment
  }, React.createElement(Dialog$1, {
    as: "div",
    className: cx("relative", className),
    initialFocus: cancelButtonRef,
    onClose: onCancel
  }, React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React.createElement("div", {
    className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
  })), React.createElement("div", {
    className: "fixed inset-0 z-10 overflow-y-auto"
  }, React.createElement("div", {
    className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
  }, React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, React.createElement(Dialog$1.Panel, {
    className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
  }, React.createElement("div", {
    className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
  }, React.createElement("div", {
    className: "sm:flex sm:items-start"
  }, iconActual, React.createElement("div", {
    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
  }, React.createElement(Dialog$1.Title, {
    as: "h3",
    className: "text-lg leading-6 text-gray-900"
  }, title), React.createElement("div", {
    className: "mt-2"
  }, React.createElement("p", {
    className: "text-sm text-gray-500"
  }, content))))), React.createElement("div", {
    className: " flex flex-row-reverse items-center justify-between bg-gray-50 px-4 py-3"
  }, React.createElement("div", {
    className: "flex flex-row-reverse items-center gap-2"
  }, confirmButtonActual, cancelButtonActual), !!extraFooter && extraFooter)))))));
};

var _excluded$1 = ["className", "intent", "size", "bordered", "uppercase", "children"];
var baseCls = /*#__PURE__*/cva("inline-flex items-center rounded-full", {
  variants: {
    intent: {
      info: "text-blue-600",
      success: "text-lime-700",
      warning: "text-orange-700",
      error: "text-red-600",
      secondary: "text-orange-600",
      tertiary: "text-gray-600",
      primary: "text-white"
    },
    bordered: {
      "true": "border"
    },
    uppercase: {
      "true": "uppercase tracking-wide"
    },
    size: {
      base: "px-2.5 py-0.5 text-xs",
      sm: "px-2 py-0.5 text-[10px] tracking-wide leading-tight",
      lg: "px-3 py-0.5 text-xs"
    }
  },
  compoundVariants: [{
    intent: "info",
    bordered: true,
    "class": "border-blue-200 bg-blue-50"
  }, {
    intent: "info",
    bordered: false,
    "class": "bg-blue-100"
  }, {
    intent: "success",
    bordered: true,
    "class": "border-lime-300 bg-lime-100"
  }, {
    intent: "success",
    bordered: false,
    "class": "bg-lime-100"
  }, {
    intent: "warning",
    bordered: true,
    "class": "border-orange-300 bg-orange-100"
  }, {
    intent: "warning",
    bordered: false,
    "class": "bg-orange-200"
  }, {
    intent: "error",
    bordered: true,
    "class": "border-red-200 bg-red-50"
  }, {
    intent: "error",
    bordered: false,
    "class": "bg-red-100"
  }, {
    intent: "tertiary",
    bordered: false,
    "class": "bg-gray-100"
  }, {
    intent: "secondary",
    bordered: true,
    "class": "bg-white border-orange-400"
  }, {
    intent: "secondary",
    bordered: false,
    "class": "bg-orange-100"
  }, {
    intent: "primary",
    bordered: true,
    "class": "border-orange-500 bg-orange-400"
  }, {
    intent: "primary",
    bordered: false,
    "class": "bg-orange-400"
  }]
});
var Badge = function Badge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "primary" : _ref$intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    _ref$uppercase = _ref.uppercase,
    uppercase = _ref$uppercase === void 0 ? false : _ref$uppercase,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var cls = classx(baseCls({
    intent: intent,
    size: size,
    bordered: bordered,
    uppercase: uppercase
  }), className);
  return React.createElement("span", Object.assign({
    className: cls
  }, props), children);
};

var _excluded$2 = ["size", "className", "labelClass", "label", "id"];
var labelStyle = /*#__PURE__*/cva("select-none text-gray-600 peer-disabled:text-gray-300", {
  variants: {
    size: {
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg"
    }
  }
});
var inputStyle = /*#__PURE__*/cva(["peer appearance-none border-gray-300 bg-gray-50 text-orange-400", "checked:ring-transparent checked:border-gray-200 hover:border-gray-200 focus:ring-orange-500/50 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-100 disabled:ring-transparent"], {
  variants: {
    size: {
      sm: "h-4 w-4 rounded",
      base: "h-5 w-5 rounded",
      lg: "h-6 w-6 rounded-md"
    }
  }
});
var containerStyle = /*#__PURE__*/cva("inline-flex items-center", {
  variants: {
    size: {
      sm: "gap-2.5",
      base: "gap-2.5",
      lg: "gap-3"
    }
  }
});
var Checkbox = function Checkbox(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    label = _ref.label,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React.createElement("div", {
    className: classx(containerStyle({
      size: size
    }), className)
  }, React.createElement("input", Object.assign({
    type: "checkbox",
    id: id,
    className: inputStyle({
      size: size
    })
  }, props)), label && React.createElement("label", {
    htmlFor: id,
    className: classx(labelStyle({
      size: size
    }), labelClass)
  }, label));
};

var titleCls = /*#__PURE__*/cva("inline-flex items-center justify-start font-bold text-gray-500 hover:text-gray-700", {
  variants: {
    size: {
      sm: "text-xs gap-1 py-2",
      base: "text-sm gap-1 py-2",
      lg: "text-base gap-2 py-2.5"
    }
  }
});
var panelCls = /*#__PURE__*/cva("flex flex-col", {
  variants: {
    size: {
      sm: "pl-5 py-1 gap-2",
      base: "pl-6 py-1.5 gap-2",
      lg: "pl-8 py-2 gap-3"
    }
  }
});
var chevronCls = /*#__PURE__*/cva("transition-transform", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-6 w-6"
    },
    open: {
      "true": "rotate-90"
    }
  }
});
var CheckboxGroup = function CheckboxGroup(_ref) {
  var title = _ref.title,
    _ref$titleClass = _ref.titleClass,
    titleClass = _ref$titleClass === void 0 ? "" : _ref$titleClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    children = _ref.children;
  return React.createElement(Disclosure, {
    defaultOpen: true
  }, function (_ref2) {
    var open = _ref2.open;
    return React.createElement(React.Fragment, null, React.createElement(Disclosure.Button, {
      className: classx(titleCls({
        size: size
      }), titleClass)
    }, React.createElement(ChevronRightIcon, {
      className: chevronCls({
        size: size,
        open: open
      })
    }), title), React.createElement(Transition, {
      enter: "transition duration-100 ease-out",
      enterFrom: "transform opacity-0",
      enterTo: "transform opacity-100",
      leave: "transition duration-75 ease-out",
      leaveFrom: "transform opacity-100",
      leaveTo: "transform opacity-0"
    }, React.createElement(Disclosure.Panel, {
      className: panelCls({
        size: size
      })
    }, React.Children.map(children, function (child) {
      return React.cloneElement(child, {
        size: size
      });
    }))));
  });
};

var containerCls = /*#__PURE__*/cva("border bg-white", {
  variants: {
    size: {
      sm: "rounded-md",
      base: "rounded-lg",
      lg: "rounded-lg"
    },
    shadow: {
      "true": "shadow-sm"
    },
    intent: {
      "default": "border-gray-300",
      danger: "border-red-200",
      light: "border-gray-200",
      info: "border-blue-200"
    }
  }
});
var Container = function Container(_ref) {
  var _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? false : _ref$shadow,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children;
  return React.createElement("div", {
    className: classx(containerCls({
      intent: intent,
      size: size,
      shadow: shadow
    }), className)
  }, children);
};

var headerCls = /*#__PURE__*/cva("flex items-center rounded-t-lg justify-between", {
  variants: {
    intent: {
      "default": "bg-gray-800 text-gray-50",
      light: "bg-gray-300 text-gray-800",
      danger: "bg-red-600 text-red-50"
    },
    size: {
      sm: "px-6 py-2 text-sm",
      base: "px-7 py-2.5 text-base",
      lg: "px-8 py-3 text-lg"
    }
  }
});
var footerCls = /*#__PURE__*/cva(" flex flex-row-reverse items-center rounded-b-lg justify-between bg-gray-50", {
  variants: {
    size: {
      sm: "px-6 py-4",
      base: "px-7 py-5",
      lg: "px-8 py-6"
    }
  }
});
var iconCls$1 = /*#__PURE__*/cva("flex items-stretch justify-center", {
  variants: {
    intent: {
      "default": "text-orange-500",
      light: "text-orange-500",
      danger: "text-red-50"
    },
    size: {
      sm: "h-5 w-5",
      base: "h-6 w-6",
      lg: "h-7 w-7"
    }
  }
});
var elementCls = /*#__PURE__*/cva("flex items-center py-2", {
  variants: {
    size: {
      sm: "gap-2",
      base: "gap-3",
      lg: "gap-3"
    }
  }
});
var dialogCls = /*#__PURE__*/cva("relative w-full transform rounded-lg bg-gray-50 text-left shadow-xl outline outline-1 outline-gray-500 transition-all", {
  variants: {
    width: {
      "default": "max-w-4xl",
      narrow: "max-w-3xl",
      spacious: "max-w-5xl"
    }
  }
});
var DialogHeader = function DialogHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    icon = _ref.icon,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    leadingHeaderElement = _ref.leadingHeaderElement,
    trailingHeaderElement = _ref.trailingHeaderElement,
    _ref$headerClass = _ref.headerClass,
    headerClass = _ref$headerClass === void 0 ? "" : _ref$headerClass,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var leadingElement = leadingHeaderElement || React.createElement("div", {
    className: elementCls({
      size: size
    })
  }, icon && React.createElement("div", {
    className: iconCls$1({
      intent: intent,
      size: size
    })
  }, icon), React.createElement(Dialog$1.Title, {
    as: "h3",
    className: "leading-6 "
  }, title));
  var trailingElement = trailingHeaderElement || React.createElement("button", {
    onClick: function onClick() {
      return onClose();
    },
    className: iconCls$1({
      size: size,
      "class": "opacity-70 outline-gray-500 hover:opacity-100"
    })
  }, React.createElement(XMarkIcon, null));
  return React.createElement("div", {
    className: classx(headerCls({
      intent: intent,
      size: size
    }), headerClass)
  }, leadingElement, trailingElement);
};
var Dialog = function Dialog(_ref2) {
  var _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? "" : _ref2$title,
    _ref2$showTitle = _ref2.showTitle,
    showTitle = _ref2$showTitle === void 0 ? true : _ref2$showTitle,
    footer = _ref2.footer,
    icon = _ref2.icon,
    _ref2$intent = _ref2.intent,
    intent = _ref2$intent === void 0 ? "default" : _ref2$intent,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? "base" : _ref2$size,
    leadingHeaderElement = _ref2.leadingHeaderElement,
    trailingHeaderElement = _ref2.trailingHeaderElement,
    _ref2$headerClass = _ref2.headerClass,
    headerClass = _ref2$headerClass === void 0 ? "" : _ref2$headerClass,
    isOpen = _ref2.isOpen,
    confirmButton = _ref2.confirmButton,
    closeButton = _ref2.closeButton,
    extraFooter = _ref2.extraFooter,
    children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? "default" : _ref2$width,
    _ref2$onConfirm = _ref2.onConfirm,
    onConfirm = _ref2$onConfirm === void 0 ? function () {} : _ref2$onConfirm,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
    _ref2$confirmLabel = _ref2.confirmLabel,
    confirmLabel = _ref2$confirmLabel === void 0 ? "Confirm" : _ref2$confirmLabel,
    _ref2$closeLabel = _ref2.closeLabel,
    closeLabel = _ref2$closeLabel === void 0 ? "Cancel" : _ref2$closeLabel,
    _ref2$cancelable = _ref2.cancelable,
    cancelable = _ref2$cancelable === void 0 ? true : _ref2$cancelable;
  var closeButtonRef = useRef(null);
  var confirmButtonActual = confirmButton || React.createElement(Button, {
    type: "button",
    intent: intent === "danger" ? "danger" : "highlight",
    size: size === "sm" ? "sm" : "base",
    onClick: function onClick() {
      return onConfirm();
    }
  }, confirmLabel);
  var closeButtonActual = closeButton || React.createElement(Button, {
    type: "button",
    intent: "secondary",
    size: size === "sm" ? "sm" : "base",
    onClick: function onClick() {
      return onClose();
    },
    ref: closeButtonRef
  }, closeLabel);
  return React.createElement(Transition.Root, {
    show: isOpen,
    as: Fragment
  }, React.createElement(Dialog$1, {
    as: "div",
    className: "relative z-20",
    initialFocus: closeButtonRef,
    onClose: cancelable ? onClose : function () {}
  }, React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React.createElement("div", {
    className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
  })), React.createElement("div", {
    className: "fixed inset-0 z-10 overflow-y-auto"
  }, React.createElement("div", {
    className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
  }, React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, React.createElement(Dialog$1.Panel, {
    className: classx(dialogCls({
      width: width
    }), className)
  }, showTitle && React.createElement(DialogHeader, {
    title: title,
    icon: icon,
    leadingHeaderElement: leadingHeaderElement,
    trailingHeaderElement: trailingHeaderElement,
    intent: intent,
    size: size,
    onClose: onClose,
    headerClass: headerClass
  }), children, footer !== null && React.createElement("div", {
    className: footerCls({
      size: size
    })
  }, footer ? footer({
    className: footerCls({
      size: size
    }),
    confirmButton: confirmButtonActual,
    cancelButton: closeButtonActual,
    onConfirm: onConfirm,
    onClose: onClose
  }) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex flex-row-reverse items-center gap-2"
  }, confirmButtonActual, closeButtonActual), !!extraFooter && extraFooter))))))));
};

var labelBaseCls = "w-full truncate text-center text-gray-700";
var FileUpload = function FileUpload(_ref) {
  var value = _ref.value,
    _ref$fileSizeLimit = _ref.fileSizeLimit,
    fileSizeLimit = _ref$fileSizeLimit === void 0 ? 20000000 : _ref$fileSizeLimit,
    fileTypes = _ref.fileTypes,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Drag file here or click to browse files" : _ref$label,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? function (sizeLimt) {
      return "File size limit: " + formatFileSize(sizeLimt);
    } : _ref$description,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? React.createElement(DocumentArrowUpIcon, {
      className: "h-12 w-12 text-orange-500"
    }) : _ref$icon,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {} : _ref$onError;
  var fileInput = useRef(null);
  // const [value, setValue] = useState<File>();
  var handleFileChange = function handleFileChange(e) {
    if (e.target.files && e.target.files.length === 1) {
      var file = e.target.files[0];
      if (file.size < fileSizeLimit) {
        onChange(file);
      } else {
        onError("Uploaded file cannot be larger than " + formatFileSize(fileSizeLimit));
      }
    }
  };
  var handleFileRemove = function handleFileRemove(e) {
    e.preventDefault();
    onChange(undefined);
    if (fileInput.current && fileInput.current.value) {
      fileInput.current.value = "";
    }
  };
  var handleFileDrop = function handleFileDrop(e) {
    if (e.dataTransfer.files.length) {
      var file = e.dataTransfer.files[0];
      var fileTypeMatches = file.type && fileTypes.indexOf(file.type) !== -1;
      var fileSuffixMatches = file.name && fileTypes.some(function (x) {
        return file.name.endsWith(x);
      });
      if (fileTypeMatches || fileSuffixMatches) {
        return;
      } else {
        onError("This file type " + file.type + " is not allowed");
      }
    }
    e.preventDefault();
  };
  return React.createElement("div", {
    className: classx("relative flex flex-col items-center gap-3 rounded-lg border-2 border-dashed p-6", className)
  }, React.createElement("input", {
    type: "file",
    title: "",
    ref: fileInput,
    accept: fileTypes.join(","),
    onChange: handleFileChange,
    onDrop: handleFileDrop,
    className: "absolute inset-0 block h-full w-full cursor-pointer opacity-0"
  }), icon, value ? React.createElement("div", {
    className: "w-full space-y-0.5"
  }, React.createElement("p", {
    className: classx(labelBaseCls, labelClass)
  }, value.name), React.createElement("p", {
    className: "w-full text-center text-sm text-gray-400"
  }, formatFileSize(value.size)), React.createElement("button", {
    className: "absolute bottom-2 right-2 text-red-400 hover:text-red-600",
    onClick: handleFileRemove
  }, React.createElement(TrashIcon, {
    className: "h-5 w-5"
  }))) : React.createElement("div", {
    className: "space-y-0.5"
  }, React.createElement("p", {
    className: classx(labelBaseCls, labelClass)
  }, label), React.createElement("div", {
    className: "w-full text-center text-sm text-gray-400"
  }, typeof description === "function" ? description(fileSizeLimit, fileTypes) : description)));
};

var LoadingCircular = function LoadingCircular(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "h-5 w-5" : _ref$className;
  return React.createElement("svg", {
    className: cx("animate-spin ", className),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, React.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), React.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
};

var LoadingDotted = function LoadingDotted(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "text-gray-500" : _ref$className,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? "2s" : _ref$duration;
  return React.createElement("svg", {
    className: classx("h-2 w-14", className),
    viewBox: "0 0 56 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;1;0.1;0.1;0.1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.1;1;0.1;0.1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    cx: "36",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.1;0.1;1;0.1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    cx: "52",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.1;0.1;0.1;1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })));
};

var _marked = /*#__PURE__*/_regeneratorRuntime().mark(pageGenerator);
function pageGenerator(current, total) {
  var i;
  return _regeneratorRuntime().wrap(function pageGenerator$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        i = 1;
      case 1:
        if (!(i <= total)) {
          _context.next = 23;
          break;
        }
        if (!(total <= 7 || i === 1 || i === total)) {
          _context.next = 7;
          break;
        }
        _context.next = 5;
        return i;
      case 5:
        _context.next = 20;
        break;
      case 7:
        if (!(i === 2)) {
          _context.next = 12;
          break;
        }
        _context.next = 10;
        return current > 4 ? null : i;
      case 10:
        _context.next = 20;
        break;
      case 12:
        if (!(i === total - 1)) {
          _context.next = 17;
          break;
        }
        _context.next = 15;
        return current < total - 3 ? null : i;
      case 15:
        _context.next = 20;
        break;
      case 17:
        if (!(Math.abs(current - i) < 2 || current <= 4 && i <= 5 || current >= total - 3 && i >= total - 4)) {
          _context.next = 20;
          break;
        }
        _context.next = 20;
        return i;
      case 20:
        ++i;
        _context.next = 1;
        break;
      case 23:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
var buttonStyle$1 = /*#__PURE__*/cva("", {
  variants: {
    size: {
      xs: "py-0.5 px-1.5",
      sm: "py-0.5 px-2",
      base: "py-0.5 px-2.5",
      lg: "py-0.5 px-3",
      xl: "py-1 px-3.5"
    }
  }
});
var resetClass = function resetClass(overrideCls) {
  return function (cls) {
    return cls.replace(/p[xy]-\d/g, "") + (" " + overrideCls);
  };
};
var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    onPageChange = _ref.onPageChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    isLoading = _ref.isLoading,
    _ref$hideForSinglePag = _ref.hideForSinglePage,
    hideForSinglePage = _ref$hideForSinglePag === void 0 ? true : _ref$hideForSinglePag;
  var page = Array.from(pageGenerator(currentPage, totalPages));
  var sizeClass = buttonStyle$1({
    size: size
  });
  if (hideForSinglePage && totalPages === 1) {
    return React.createElement("div", null);
  } else {
    return React.createElement("div", {
      className: "flex items-center gap-2"
    }, React.createElement("button", {
      className: "p-1 text-gray-400 outline-orange-400 hover:text-orange-500 disabled:text-gray-200",
      onClick: function onClick() {
        return onPageChange(Math.max(1, currentPage - 1));
      },
      disabled: currentPage <= 1
    }, React.createElement(ChevronLeftIcon, {
      className: "h-6 w-6"
    })), isLoading && new Array(7).fill(0).map(function (_, key) {
      return React.createElement(Button, {
        className: resetClass(sizeClass + " animate-pulse"),
        disabled: true,
        key: key,
        onClick: function onClick() {},
        size: size
      }, "\xA0");
    }), !isLoading && page.map(function (p, idx) {
      return p === null ? React.createElement("div", {
        className: sizeClass + " flex flex-col items-center justify-center",
        key: idx
      }, React.createElement(EllipsisHorizontalIcon, {
        className: "h-5 w-5 text-gray-400"
      })) : React.createElement(Button, {
        className: resetClass(sizeClass),
        key: idx,
        intent: p === currentPage ? "highlight" : "secondary",
        onClick: function onClick() {
          return onPageChange(p);
        },
        size: size
      }, p);
    }), React.createElement("button", {
      className: "p-1 text-gray-400 outline-orange-400 hover:text-orange-500 disabled:text-gray-200",
      disabled: currentPage >= totalPages,
      onClick: function onClick() {
        return onPageChange(Math.min(currentPage + 1, totalPages));
      }
    }, React.createElement(ChevronRightIcon, {
      className: "h-6 w-6"
    })));
  }
};

var elementCls$1 = /*#__PURE__*/cva("flex items-center py-2", {
  variants: {
    size: {
      sm: "gap-2",
      base: "gap-3",
      lg: "gap-3"
    }
  }
});
var iconCls$2 = /*#__PURE__*/cva("flex items-stretch justify-center", {
  variants: {
    intent: {
      "default": "text-orange-500",
      light: "text-orange-500",
      danger: "text-red-500"
    },
    size: {
      sm: "h-5 w-5",
      base: "h-6 w-6",
      lg: "h-7 w-7"
    }
  }
});
var headerCls$1 = /*#__PURE__*/cva("flex items-center justify-between", {
  variants: {
    intent: {
      "default": "bg-gray-100 text-gray-600",
      light: "text-gray-600",
      danger: "bg-red-50 text-red-600"
    },
    size: {
      sm: "px-5 py-2 text-xs",
      base: "px-7 py-2.5 text-sm",
      lg: "px-8 py-3 text-base"
    }
  }
});
var bodyCls = /*#__PURE__*/cva("text-gray-800", {
  variants: {
    size: {
      sm: "px-5 py-5 text-xs",
      base: "px-7 py-6 text-sm",
      lg: "px-8 py-7 text-base"
    }
  }
});
var containerCls$1 = /*#__PURE__*/cva("divide-y overflow-hidden", {
  variants: {
    intent: {
      "default": "divide-gray-200",
      light: "divide-gray-100",
      danger: "divide-red-200"
    }
  }
});
var PanelHeader = function PanelHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    icon = _ref.icon,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    leadingHeaderElement = _ref.leadingHeaderElement,
    trailingHeaderElement = _ref.trailingHeaderElement,
    _ref$headerClass = _ref.headerClass,
    headerClass = _ref$headerClass === void 0 ? "" : _ref$headerClass;
  var leadingElement = leadingHeaderElement || React.createElement("div", {
    className: elementCls$1({
      size: size
    })
  }, icon && React.createElement("div", {
    className: iconCls$2({
      intent: intent,
      size: size
    })
  }, icon), React.createElement("div", null, title));
  return React.createElement("div", {
    className: classx(headerCls$1({
      intent: intent,
      size: size
    }), headerClass)
  }, leadingElement, !!trailingHeaderElement && trailingHeaderElement);
};
var Panel = function Panel(_ref2) {
  var title = _ref2.title,
    icon = _ref2.icon,
    shadow = _ref2.shadow,
    leadingHeaderElement = _ref2.leadingHeaderElement,
    trailingHeaderElement = _ref2.trailingHeaderElement,
    footer = _ref2.footer,
    _ref2$intent = _ref2.intent,
    intent = _ref2$intent === void 0 ? "default" : _ref2$intent,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? "base" : _ref2$size,
    _ref2$headerClass = _ref2.headerClass,
    headerClass = _ref2$headerClass === void 0 ? "" : _ref2$headerClass,
    _ref2$bodyClass = _ref2.bodyClass,
    bodyClass = _ref2$bodyClass === void 0 ? "" : _ref2$bodyClass,
    _ref2$className = _ref2.className,
    _className = _ref2$className === void 0 ? "" : _ref2$className,
    children = _ref2.children;
  return React.createElement(Container, {
    className: function className(cls) {
      return classx(cx(cls, containerCls$1({
        intent: intent
      })), _className);
    },
    intent: intent,
    shadow: shadow,
    size: size
  }, React.createElement(PanelHeader, {
    title: title,
    icon: icon,
    leadingHeaderElement: leadingHeaderElement,
    trailingHeaderElement: trailingHeaderElement,
    intent: intent,
    size: size,
    headerClass: headerClass
  }), React.createElement("div", {
    className: classx(bodyCls({
      size: size
    }), bodyClass)
  }, children), !!footer && footer);
};

var _excluded$3 = ["size", "className", "labelClass", "label", "id"];
var labelStyle$1 = /*#__PURE__*/cva("select-none text-gray-600 peer-disabled:text-gray-300", {
  variants: {
    size: {
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg"
    }
  }
});
var inputStyle$1 = /*#__PURE__*/cva(["peer appearance-none border-gray-300 bg-gray-50 text-orange-400 rounded-full", "checked:ring-transparent checked:border-gray-200 hover:border-gray-200 focus:ring-orange-500/50 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-100 disabled:ring-transparent"], {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-6 w-6"
    }
  }
});
var containerStyle$1 = /*#__PURE__*/cva("inline-flex items-center", {
  variants: {
    size: {
      sm: "gap-2.5",
      base: "gap-2.5",
      lg: "gap-3"
    }
  }
});
var Checkbox$1 = function Checkbox(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    label = _ref.label,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React.createElement("div", {
    className: classx(containerStyle$1({
      size: size
    }), className)
  }, React.createElement("input", Object.assign({
    type: "radio",
    id: id,
    className: inputStyle$1({
      size: size
    })
  }, props)), label && React.createElement("label", {
    htmlFor: id,
    className: classx(labelStyle$1({
      size: size
    }), labelClass)
  }, label));
};

var containerCls$2 = /*#__PURE__*/cva("flex", {
  variants: {
    labelPlacement: {
      left: "flex-row gap-2 items-center",
      top: "flex-col gap-1 items-stretch"
    }
  }
});
var labelCls = /*#__PURE__*/cva("block text-gray-500", {
  variants: {
    labelPlacement: {
      left: "",
      top: ""
    },
    size: {
      sm: "",
      base: "",
      lg: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-basen"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var buttonCls = /*#__PURE__*/cva("relative block w-full cursor-default text-left group", {
  variants: {
    size: {
      sm: "rounded-md py-1.5 pl-3 pr-9 text-sm",
      base: "rounded-lg py-2 pl-3 pr-10 text-base ",
      lg: "rounded-lg py-3 pl-4 pr-12 text-base"
    },
    variant: {
      normal: ["border border-gray-300 bg-white text-gray-700", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      highlight: ["border border-orange-400 text-white", "bg-gradient-to-br from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600 active:from-orange-600 active:to-red-600", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      borderless: "text-gray-700"
    }
  }
});
var buttonIconCls = /*#__PURE__*/cva("", {
  variants: {
    wrapper: {
      "true": "pointer-events-none absolute inset-y-0 right-2 flex items-center "
    },
    size: {
      sm: "",
      base: "",
      lg: ""
    },
    variant: {
      normal: "text-gray-400",
      highlight: "text-orange-300",
      borderless: "text-gray-400 group-hover:text-orange-500"
    }
  },
  compoundVariants: [{
    size: "sm",
    wrapper: false,
    variant: "borderless",
    "class": "h-4 w-4"
  }, {
    size: "sm",
    wrapper: false,
    "class": "h-5 w-5"
  }, {
    size: "base",
    wrapper: false,
    "class": "h-5 w-5"
  }, {
    size: "lg",
    wrapper: false,
    "class": "h-6 w-6"
  }]
});
var optionCls = /*#__PURE__*/cva("relative cursor-pointer select-none", {
  variants: {
    size: {
      sm: "text-sm py-1.5",
      base: "text-base py-2",
      lg: "text-base py-3"
    },
    checkIconPlacement: {
      left: "",
      right: ""
    },
    active: {
      "true": "bg-orange-100 text-orange-500",
      "false": "text-gray-700"
    }
  },
  compoundVariants: [{
    size: "sm",
    checkIconPlacement: "left",
    "class": "pl-7 pr-3"
  }, {
    size: "sm",
    checkIconPlacement: "right",
    "class": "pl-3 pr-8"
  }, {
    size: "base",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "base",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }, {
    size: "lg",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "lg",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }]
});
var optionCheckCls = /*#__PURE__*/cva("", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-5 w-5"
    },
    checkIconPlacement: {
      left: "left-1.5",
      right: "right-4"
    },
    wrapper: {
      "true": "absolute inset-y-0 flex items-center"
    },
    active: {
      "true": "text-orange-500",
      "false": "text-orange-400"
    }
  }
});
var extraCls = /*#__PURE__*/cva("border-gray-100 text-orange-500", {
  variants: {
    size: {
      sm: "text-sm py-1.5 px-3",
      base: "text-base py-2 px-3",
      lg: "text-base py-3 px-3"
    },
    leading: {
      "true": "border-b",
      "false": "border-t"
    }
  }
});
var defaultFieldElement = function defaultFieldElement(value, displayField) {
  return React.createElement("span", {
    className: "block truncate"
  }, (value === undefined || value === null) && "\xA0", value && displayField !== undefined && value[displayField], value && !displayField && value);
};
var defaultOptionElement = function defaultOptionElement(option, displayField, selected) {
  return React.createElement("span", {
    className: cx(selected ? "font-bold" : "font-normal", "block truncate")
  }, displayField ? option[displayField] : option);
};
var SelectField = function SelectField(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    _ref$checkIconPlaceme = _ref.checkIconPlacement,
    checkIconPlacement = _ref$checkIconPlaceme === void 0 ? "right" : _ref$checkIconPlaceme,
    _ref$fieldElement = _ref.fieldElement,
    fieldElement = _ref$fieldElement === void 0 ? defaultFieldElement : _ref$fieldElement,
    _ref$optionElement = _ref.optionElement,
    optionElement = _ref$optionElement === void 0 ? defaultOptionElement : _ref$optionElement,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "normal" : _ref$variant,
    options = _ref.options,
    displayField = _ref.displayField,
    value = _ref.value,
    menuExtra = _ref.menuExtra,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$fieldClass = _ref.fieldClass,
    fieldClass = _ref$fieldClass === void 0 ? "" : _ref$fieldClass,
    _ref$noSelection = _ref.noSelection,
    noSelection = _ref$noSelection === void 0 ? false : _ref$noSelection,
    listboxCls = _ref.listboxCls;
  var _useFloating = useFloating({
      placement: "bottom-start",
      middleware: [flip(), offset(function (_ref2) {
        var placement = _ref2.placement;
        return placement.indexOf("bottom") >= 0 ? 2 : 12;
      }), shift()]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy;
  return React.createElement(Listbox, {
    value: value,
    onChange: onChange,
    disabled: disabled
  }, function (_ref3) {
    var _refs$reference$curre;
    var open = _ref3.open;
    return React.createElement("div", {
      className: classx(containerCls$2({
        labelPlacement: labelPlacement
      }), className)
    }, label && React.createElement(Listbox.Label, {
      className: classx(labelCls({
        size: size,
        labelPlacement: labelPlacement
      }), labelClass)
    }, label), React.createElement("div", {
      className: "relative flex-grow"
    }, React.createElement(Listbox.Button, {
      ref: refs.setReference,
      className: classx(buttonCls({
        size: size,
        variant: variant
      }), disabled ? "opacity-50 " + fieldClass : fieldClass)
    }, typeof fieldElement === "function" ? fieldElement(value, displayField) : fieldElement, React.createElement("span", {
      className: buttonIconCls({
        size: size,
        variant: variant,
        wrapper: true
      })
    }, React.createElement(ChevronUpDownIcon, {
      className: buttonIconCls({
        size: size,
        variant: variant,
        wrapper: false
      }),
      "aria-hidden": "true"
    }))), React.createElement(Portal, null, React.createElement(Transition, {
      show: open,
      as: Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "transition ease-in duration-100",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    }, React.createElement(Listbox.Options, {
      style: {
        position: strategy,
        top: y != null ? y : 0,
        left: x != null ? x : 0,
        width: (_refs$reference$curre = refs.reference.current) == null ? void 0 : _refs$reference$curre.getBoundingClientRect().width
      },
      ref: refs.setFloating,
      className: cx("absolute z-10 mt-1 max-h-60 w-fit overflow-auto rounded-md border border-orange-200 bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", listboxCls ? listboxCls : "w-full")
    }, (menuExtra == null ? void 0 : menuExtra.leading) && React.createElement("div", {
      className: extraCls({
        size: size,
        leading: true
      })
    }, menuExtra.leading), options.map(function (option, idx) {
      return React.createElement(Listbox.Option, {
        key: idx,
        className: function className(_ref4) {
          var active = _ref4.active;
          return optionCls({
            size: size,
            checkIconPlacement: checkIconPlacement,
            active: active
          });
        },
        value: option
      }, function (_ref5) {
        var selected = _ref5.selected,
          active = _ref5.active;
        return React.createElement(React.Fragment, null, typeof optionElement === "function" ? optionElement(option, displayField, selected && !noSelection) : optionElement, selected && !noSelection ? React.createElement("span", {
          className: optionCheckCls({
            wrapper: true,
            checkIconPlacement: checkIconPlacement,
            active: active
          })
        }, React.createElement(CheckIcon, {
          className: optionCheckCls({
            size: size
          }),
          "aria-hidden": "true"
        })) : null);
      });
    }), (menuExtra == null ? void 0 : menuExtra.trailing) && React.createElement("div", {
      className: extraCls({
        size: size,
        leading: false
      })
    }, menuExtra.trailing))))));
  });
};

var textStyle = /*#__PURE__*/cva("animate-pulse", {
  variants: {
    variant: {
      "default": "bg-gray-200"
    },
    size: {
      sm: "h-3.5 rounded",
      base: "h-4 rounded-md",
      lg: "h-5 rounded-lg"
    }
  }
});
var spacingStyle = /*#__PURE__*/cva("", {
  variants: {
    size: {
      sm: "space-y-1.5 py-0.5",
      base: "space-y-2 py-1",
      lg: "space-y-2.5 py-1"
    }
  }
});
var pictureStyle = /*#__PURE__*/cva("animate-pulse rounded-full", {
  variants: {
    variant: {
      "default": "bg-gray-200"
    }
  }
});
var Skeleton = function Skeleton(_ref) {
  var children = _ref.children,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading,
    _ref$lines = _ref.lines,
    lines = _ref$lines === void 0 ? 1 : _ref$lines,
    _ref$isPicture = _ref.isPicture,
    isPicture = _ref$isPicture === void 0 ? false : _ref$isPicture,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size;
  if (isLoading) {
    if (isPicture) {
      var skeletonCls = classx(pictureStyle({
        variant: variant
      }), className);
      return React.createElement("div", {
        className: skeletonCls
      });
    } else {
      var _skeletonCls = classx(textStyle({
        size: size,
        variant: variant
      }), className);
      return React.createElement("div", {
        className: spacingStyle({
          size: size
        })
      }, Array.from(Array(lines)).map(function (_, idx) {
        return React.createElement("div", {
          className: cx(_skeletonCls, idx === lines - 1 && idx ? "w-2/3" : ""),
          key: idx
        });
      }));
    }
  } else {
    return React.createElement(React.Fragment, null, children);
  }
};

var _excluded$4 = ["children", "className", "labelClass", "inputClass", "size", "variant", "intent", "labelPlacement", "label", "leadingIcon", "trailingIcon", "showClearButton", "onChange", "onClear", "id"];
var containerCls$3 = /*#__PURE__*/cva("flex", {
  variants: {
    labelPlacement: {
      top: "flex-col items-stretch gap-1",
      left: "flex-row items-center gap-3"
    }
  }
});
var labelCls$1 = /*#__PURE__*/cva("block text-gray-500", {
  variants: {
    size: {
      sm: "",
      base: "",
      lg: ""
    },
    labelPlacement: {
      top: "",
      left: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-base"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var clearButtonCls = /*#__PURE__*/cva("text-gray-400 hover:text-orange-500 absolute", {
  variants: {
    size: {
      sm: "w-5 h-5 top-1.5 right-2",
      base: "w-6 h-6 top-2 right-3",
      lg: "w-7 h-7 top-2.5 right-3"
    }
  }
});
var iconCls$3 = /*#__PURE__*/cva("pointer-events-none absolute flex items-center justify-center text-orange-400", {
  variants: {
    size: {
      sm: "w-5 h-5 top-1.5",
      base: "w-6 h-6 top-2",
      lg: "w-7 h-7 top-2.5"
    },
    isLeading: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    isLeading: true,
    "class": "left-2"
  }, {
    size: "sm",
    isLeading: false,
    "class": "right-2"
  }, {
    size: "base",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "base",
    isLeading: false,
    "class": "right-3"
  }, {
    size: "lg",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "lg",
    isLeading: false,
    "class": "right-3"
  }]
});
var inputCls = /*#__PURE__*/cva(["block w-full border outline-none", "text-gray-700  placeholder:text-gray-400", "focus:bg-white", "disabled:bg-gray-100 disabled:text-gray-400"], {
  variants: {
    intent: {
      "default": "focus:border-orange-500 focus:ring-2 focus:ring-orange-500/50",
      success: "border-lime-400 bg-lime-50 focus:border-lime-500 focus:ring-2 focus:ring-lime-500/50",
      error: "border-red-300 bg-red-50 focus:border-red-500 focus:ring-2 focus:ring-red-500/50"
    },
    variant: {
      "default": "border-gray-300 bg-gray-50",
      borderless: "border-transparent shadow-inner",
      light: "border-gray-300"
    },
    size: {
      sm: ["text-sm py-1.5 rounded-md", "py-1"],
      base: ["text-base py-2 rounded-lg", "py-2"],
      lg: ["text-base py-3 rounded-lg", "py-3"]
    },
    hasLeadingIcon: {
      "true": ""
    },
    hasTrailingIcon: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    hasLeadingIcon: true,
    "class": "pl-9 pr-3"
  }, {
    size: "base",
    hasLeadingIcon: true,
    "class": "pl-11 pr-3"
  }, {
    size: "lg",
    hasLeadingIcon: true,
    "class": "pl-12 pr-5"
  }, {
    size: "sm",
    hasTrailingIcon: true,
    "class": "pr-9 pl-3"
  }, {
    size: "base",
    hasTrailingIcon: true,
    "class": "pr-11 pl-3"
  }, {
    size: "lg",
    hasTrailingIcon: true,
    "class": "pr-12 pl-5"
  }, {
    size: "sm",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "base",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "lg",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-5"
  }]
});
var TextField = function TextField(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$inputClass = _ref.inputClass,
    inputClass = _ref$inputClass === void 0 ? "" : _ref$inputClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    label = _ref.label,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    _ref$showClearButton = _ref.showClearButton,
    showClearButton = _ref$showClearButton === void 0 ? false : _ref$showClearButton,
    _onChange = _ref.onChange,
    _ref$onClear = _ref.onClear,
    onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var _useState = useState(false),
    clearButtonVisible = _useState[0],
    setClearButtonVisible = _useState[1];
  return React.createElement("div", {
    className: classx(containerCls$3({
      labelPlacement: labelPlacement
    }), className)
  }, label && React.createElement("label", {
    htmlFor: id,
    className: classx(labelCls$1({
      size: size,
      labelPlacement: labelPlacement
    }), labelClass)
  }, label), React.createElement("div", {
    className: "relative rounded-md"
  }, leadingIcon && React.createElement("div", {
    className: iconCls$3({
      size: size,
      isLeading: true
    })
  }, leadingIcon), React.createElement("input", Object.assign({
    id: id,
    className: classx(inputCls({
      size: size,
      variant: variant,
      intent: intent,
      hasLeadingIcon: !!leadingIcon,
      hasTrailingIcon: !!trailingIcon
    }), inputClass),
    onChange: function onChange(e) {
      setClearButtonVisible(!!e.target.value && !e.target.disabled);
      _onChange && _onChange(e);
    }
  }, props)), showClearButton && clearButtonVisible && React.createElement("button", {
    className: clearButtonCls({
      size: size
    }),
    onClick: function onClick() {
      return onClear();
    }
  }, React.createElement(XMarkIcon, {
    className: "h-5/6 w-5/6"
  })), trailingIcon && React.createElement("div", {
    className: iconCls$3({
      size: size,
      isLeading: false
    })
  }, trailingIcon)));
};

var _excluded$5 = ["className", "labelClass", "inputClass", "size", "variant", "intent", "labelPlacement", "label", "leadingIcon", "trailingIcon", "showClearButton", "onChange", "onClear", "id"];
// HTMLTextAreaElement
var containerCls$4 = /*#__PURE__*/cva("flex", {
  variants: {
    labelPlacement: {
      top: "flex-col items-stretch gap-1",
      left: "flex-row items-center gap-3"
    }
  }
});
var labelCls$2 = /*#__PURE__*/cva("block text-gray-500", {
  variants: {
    size: {
      sm: "",
      base: "",
      lg: ""
    },
    labelPlacement: {
      top: "",
      left: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-base"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var clearButtonCls$1 = /*#__PURE__*/cva("text-gray-400 hover:text-orange-500 absolute", {
  variants: {
    size: {
      sm: "w-5 h-5 top-2 right-2",
      base: "w-6 h-6 top-2.5 right-3",
      lg: "w-7 h-7 top-3 right-3"
    }
  }
});
var iconCls$4 = /*#__PURE__*/cva("pointer-events-none absolute flex items-center justify-center text-orange-400", {
  variants: {
    size: {
      sm: "w-5 h-5 top-1.5",
      base: "w-6 h-6 top-2",
      lg: "w-7 h-7 top-2.5"
    },
    isLeading: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    isLeading: true,
    "class": "left-2"
  }, {
    size: "sm",
    isLeading: false,
    "class": "right-2"
  }, {
    size: "base",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "base",
    isLeading: false,
    "class": "right-3"
  }, {
    size: "lg",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "lg",
    isLeading: false,
    "class": "right-3"
  }]
});
var inputCls$1 = /*#__PURE__*/cva(["block w-full border outline-none", "text-gray-700  placeholder:text-gray-400", "focus:bg-white", "disabled:bg-gray-100 disabled:text-gray-400"], {
  variants: {
    intent: {
      "default": "focus:border-orange-500 focus:ring-2 focus:ring-orange-500/50",
      success: "border-lime-400 bg-lime-50 focus:border-lime-500 focus:ring-2 focus:ring-lime-500/50",
      error: "border-red-300 bg-red-50 focus:border-red-500 focus:ring-2 focus:ring-red-500/50"
    },
    variant: {
      "default": "border-gray-300 bg-gray-50",
      borderless: "border-transparent shadow-inner",
      light: "border-gray-300"
    },
    size: {
      sm: ["text-sm py-1.5 rounded-md", "py-1"],
      base: ["text-base py-2 rounded-lg", "py-2"],
      lg: ["text-base py-3 rounded-lg", "py-3"]
    },
    hasLeadingIcon: {
      "true": ""
    },
    hasTrailingIcon: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    hasLeadingIcon: true,
    "class": "pl-9 pr-3"
  }, {
    size: "base",
    hasLeadingIcon: true,
    "class": "pl-11 pr-3"
  }, {
    size: "lg",
    hasLeadingIcon: true,
    "class": "pl-12 pr-5"
  }, {
    size: "sm",
    hasTrailingIcon: true,
    "class": "pr-9 pl-3"
  }, {
    size: "base",
    hasTrailingIcon: true,
    "class": "pr-11 pl-3"
  }, {
    size: "lg",
    hasTrailingIcon: true,
    "class": "pr-12 pl-5"
  }, {
    size: "sm",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "base",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "lg",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-5"
  }]
});
var TextAreaField = function TextAreaField(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$inputClass = _ref.inputClass,
    inputClass = _ref$inputClass === void 0 ? "" : _ref$inputClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    label = _ref.label,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    _ref$showClearButton = _ref.showClearButton,
    showClearButton = _ref$showClearButton === void 0 ? false : _ref$showClearButton,
    _onChange = _ref.onChange,
    _ref$onClear = _ref.onClear,
    onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var _useState = useState(false),
    clearButtonVisible = _useState[0],
    setClearButtonVisible = _useState[1];
  return React.createElement("div", {
    className: classx(containerCls$4({
      labelPlacement: labelPlacement
    }), className)
  }, label && React.createElement("label", {
    htmlFor: id,
    className: classx(labelCls$2({
      size: size,
      labelPlacement: labelPlacement
    }), labelClass)
  }, label), React.createElement("div", {
    className: "relative rounded-md"
  }, leadingIcon && React.createElement("div", {
    className: iconCls$4({
      size: size,
      isLeading: true
    })
  }, leadingIcon), React.createElement("textarea", Object.assign({
    id: id,
    className: classx(inputCls$1({
      size: size,
      variant: variant,
      intent: intent,
      hasLeadingIcon: !!leadingIcon,
      hasTrailingIcon: !!trailingIcon
    }), inputClass),
    onChange: function onChange(e) {
      setClearButtonVisible(!!e.target.value && !e.target.disabled);
      _onChange && _onChange(e);
    }
  }, props)), showClearButton && clearButtonVisible && React.createElement("button", {
    className: clearButtonCls$1({
      size: size
    }),
    onClick: function onClick() {
      return onClear();
    }
  }, React.createElement(XMarkIcon, {
    className: "h-5/6 w-5/6"
  })), trailingIcon && React.createElement("div", {
    className: iconCls$4({
      size: size,
      isLeading: false
    })
  }, trailingIcon)));
};

var CONTAINER_CLS = "";
var TOOLTIP_CLS = "rounded-md bg-gray-50 px-3 py-1.5 text-xs font-normal text-gray-600 shadow-lg ring-1 ring-gray-500/30 z-30";
var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    _ref$tooltipOffset = _ref.tooltipOffset,
    tooltipOffset = _ref$tooltipOffset === void 0 ? 5 : _ref$tooltipOffset,
    tooltipClassName = _ref.tooltipClassName,
    _ref$event = _ref.event,
    event = _ref$event === void 0 ? "hover" : _ref$event,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 800 : _ref$delay;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useFloating = useFloating$1({
      open: open,
      onOpenChange: setOpen,
      placement: "bottom-start",
      middleware: [flip$1(), offset$1(tooltipOffset), shift$1()]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy,
    context = _useFloating.context;
  var _useInteractions = useInteractions([useHover(context, {
      delay: delay,
      enabled: event === "hover" && !disabled
    }), useClick(context, {
      enabled: event === "click" && !disabled
    })]),
    getReferenceProps = _useInteractions.getReferenceProps,
    getFloatingProps = _useInteractions.getFloatingProps;
  var containerCls = calculateClasses(className, CONTAINER_CLS);
  var tooltipCls = calculateClasses(tooltipClassName, TOOLTIP_CLS);
  return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({
    className: containerCls,
    ref: refs.setReference
  }, getReferenceProps()), children), React.createElement(Portal, null, React.createElement(Transition, Object.assign({
    show: open,
    enter: "transition-opacity duration-75",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-150",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    ref: refs.setFloating,
    style: {
      position: strategy,
      top: y != null ? y : 0,
      left: x != null ? x : 0
    },
    className: tooltipCls
  }, getFloatingProps()), content)));
};

var containerCls$5 = /*#__PURE__*/cva("flex relative", {
  variants: {
    labelPlacement: {
      left: "flex-row gap-2 items-center",
      top: "flex-col gap-1 items-stretch"
    }
  }
});
var labelCls$3 = /*#__PURE__*/cva("block text-gray-500", {
  variants: {
    labelPlacement: {
      left: "",
      top: ""
    },
    size: {
      sm: "",
      base: "",
      lg: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-basen"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var inputCls$2 = /*#__PURE__*/cva("relative block w-full cursor-default text-left group placeholder:text-gray-300", {
  variants: {
    size: {
      sm: "rounded-md py-1.5 pl-3 pr-9 text-sm",
      base: "rounded-lg py-2 pl-3 pr-10 text-base ",
      lg: "rounded-lg py-3 pl-4 pr-12 text-base"
    },
    variant: {
      normal: ["border border-gray-300 bg-white text-gray-700", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      highlight: ["border border-orange-400 text-white", "bg-gradient-to-br from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600 active:from-orange-600 active:to-red-600", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      borderless: "text-gray-700"
    }
  }
});
var optionCls$1 = /*#__PURE__*/cva("relative cursor-pointer select-none", {
  variants: {
    size: {
      sm: "text-sm py-1.5",
      base: "text-base py-2",
      lg: "text-base py-3"
    },
    checkIconPlacement: {
      left: "",
      right: ""
    },
    active: {
      "true": "bg-orange-100 text-orange-500",
      "false": "text-gray-700"
    }
  },
  compoundVariants: [{
    size: "sm",
    checkIconPlacement: "left",
    "class": "pl-7 pr-3"
  }, {
    size: "sm",
    checkIconPlacement: "right",
    "class": "pl-3 pr-8"
  }, {
    size: "base",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "base",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }, {
    size: "lg",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "lg",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }]
});
var optionCheckCls$1 = /*#__PURE__*/cva("", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-5 w-5"
    },
    checkIconPlacement: {
      left: "left-1.5",
      right: "right-4"
    },
    wrapper: {
      "true": "absolute inset-y-0 flex items-center"
    },
    active: {
      "true": "text-orange-500",
      "false": "text-orange-400"
    }
  }
});
var ComboboxFields = function ComboboxFields(_ref) {
  var _refs$reference$curre;
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    _ref$checkIconPlaceme = _ref.checkIconPlacement,
    checkIconPlacement = _ref$checkIconPlaceme === void 0 ? "right" : _ref$checkIconPlaceme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "normal" : _ref$variant,
    options = _ref.options,
    displayField = _ref.displayField,
    value = _ref.value,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onInputChange = _ref.onInputChange,
    onInputChange = _ref$onInputChange === void 0 ? function () {} : _ref$onInputChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$fieldClass = _ref.fieldClass,
    fieldClass = _ref$fieldClass === void 0 ? "" : _ref$fieldClass,
    listboxCls = _ref.listboxCls,
    id = _ref.id,
    placeholder = _ref.placeholder,
    textFieldProps = _ref.textFieldProps;
  var _useState = useState(""),
    query = _useState[0],
    setQuery = _useState[1];
  var filteredData = query === "" ? options : options.filter(function (option) {
    return (displayField ? option[displayField] : String(option)).toLowerCase().replace(/\s+/g, "").includes(query.toLowerCase().replace(/\s+/g, ""));
  });
  var _useFloating = useFloating({
      placement: "bottom-start",
      middleware: [flip(), offset(function (_ref2) {
        var placement = _ref2.placement;
        return placement.indexOf("bottom") >= 0 ? 2 : 12;
      }), shift()]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy;
  return options && options.length > 0 ? React.createElement("div", {
    className: classx(containerCls$5({
      labelPlacement: labelPlacement
    }), className)
  }, label && React.createElement("label", {
    htmlFor: id,
    className: classx(labelCls$3({
      size: size,
      labelPlacement: labelPlacement
    }), labelClass)
  }, label), React.createElement(Combobox, {
    value: value,
    onChange: onChange,
    disabled: disabled
  }, React.createElement("div", {
    className: ""
  }, React.createElement("div", {
    className: "relative",
    ref: refs.setReference
  }, React.createElement(Combobox.Input, {
    id: id,
    className: classx(inputCls$2({
      size: size,
      variant: variant
    }), disabled ? "opacity-50 " + fieldClass : fieldClass),
    displayValue: function displayValue(data) {
      if (displayField) {
        return displayField && data ? data[displayField] : "";
      } else {
        return String(data);
      }
    },
    placeholder: placeholder,
    onChange: function onChange(event) {
      setQuery(event.target.value);
      onInputChange(event.target.value);
    }
  }), React.createElement(Combobox.Button, {
    className: "absolute inset-y-0 right-0 flex items-center pr-2"
  }, React.createElement(ChevronUpDownIcon, {
    className: "h-5 w-5 text-gray-400",
    "aria-hidden": "true"
  }))), React.createElement(Portal, null, React.createElement(Transition, {
    as: Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    afterLeave: function afterLeave() {
      return setQuery("");
    }
  }, React.createElement(Combobox.Options, {
    ref: refs.setFloating,
    style: {
      position: strategy,
      top: y != null ? y : 0,
      left: x != null ? x : 0,
      width: (_refs$reference$curre = refs.reference.current) == null ? void 0 : _refs$reference$curre.getBoundingClientRect().width
    },
    className: cx("absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md border border-orange-200 bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", listboxCls ? listboxCls : "w-full")
  }, filteredData.length === 0 && query !== "" ? React.createElement("div", null, query.length > 0 && React.createElement(Combobox.Option, {
    className: function className(_ref3) {
      var active = _ref3.active;
      return optionCls$1({
        size: size,
        checkIconPlacement: checkIconPlacement,
        active: active
      });
    },
    value: query
  }, "Create \"", query, "\"")) : filteredData.map(function (data, idx) {
    return React.createElement(Combobox.Option, {
      key: idx,
      className: function className(_ref4) {
        var active = _ref4.active;
        return optionCls$1({
          size: size,
          checkIconPlacement: checkIconPlacement,
          active: active
        });
      },
      value: data
    }, function (_ref5) {
      var selected = _ref5.selected,
        active = _ref5.active;
      return React.createElement(React.Fragment, null, React.createElement("span", {
        className: "block truncate " + (selected ? "font-bold" : "font-normal")
      }, displayField ? data[displayField] : String(data)), selected ? React.createElement("span", {
        className: optionCheckCls$1({
          wrapper: true,
          checkIconPlacement: checkIconPlacement,
          active: active
        })
      }, React.createElement(CheckIcon, {
        className: optionCheckCls$1({
          size: size
        }),
        "aria-hidden": "true"
      })) : null);
    });
  }))))))) : React.createElement(TextField, Object.assign({}, textFieldProps));
};

export { Alert, Badge, Button, Checkbox, CheckboxGroup, ComboboxFields as ComboboxField, Container, Dialog, FileUpload, LoadingCircular, LoadingDotted, Pagination, Panel, ProgressCircular, Checkbox$1 as Radio, SelectField, Skeleton, TextAreaField, TextField, Tooltip, buttonCls, buttonIconCls, calculateClasses, classx, containerCls$2 as containerCls, defaultFieldElement, defaultOptionElement, optionCheckCls, optionCls };
//# sourceMappingURL=ui-base.esm.js.map
